import { useState } from 'react';
import { toastManager } from './ToastContainer';

function SettingsSection() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    
    const handleChangePassword = (e) => {
        e.preventDefault();
        
        if (!newPassword || !confirmPassword) {
            toastManager.error('Error', 'Please fill all fields');
            return;
        }
        
        if (newPassword !== confirmPassword) {
            toastManager.error('Error', 'Passwords do not match');
            return;
        }
        
        if (newPassword.length < 8) {
            toastManager.error('Error', 'Password must be at least 8 characters');
            return;
        }
        
        // In production, this would call an API
        toastManager.success('Success', 'Password updated successfully (demo mode)');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
    };
    
    const handleBackup = () => {
        toastManager.info('Backup', 'Backup feature will be available soon');
    };
    
    return (
        <div className="admin-section">
            <h2 className="admin-section-title">
                <i className="fas fa-cog"></i> Settings
            </h2>
            
            {/* Change Password */}
            <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '16px', padding: '30px', marginBottom: '30px', maxWidth: '600px' }}>
                <h3 style={{ color: '#d4af37', marginBottom: '20px' }}>
                    <i className="fas fa-lock"></i> Change Admin Password
                </h3>
                
                <form onSubmit={handleChangePassword}>
                    <div className="admin-form-group">
                        <label>Current Password</label>
                        <input
                            type="password"
                            className="admin-input"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            placeholder="Enter current password"
                        />
                    </div>
                    
                    <div className="admin-form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            className="admin-input"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                        />
                    </div>
                    
                    <div className="admin-form-group">
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            className="admin-input"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                        />
                    </div>
                    
                    <button type="submit" className="admin-btn">
                        <i className="fas fa-save"></i> Update Password
                    </button>
                </form>
            </div>
            
            {/* System Settings */}
            <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '16px', padding: '30px' }}>
                <h3 style={{ color: '#d4af37', marginBottom: '20px' }}>
                    <i className="fas fa-database"></i> System Management
                </h3>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
                    <button className="admin-btn admin-btn-success" onClick={handleBackup}>
                        <i className="fas fa-download"></i> Backup Database
                    </button>
                    
                    <button className="admin-btn admin-btn-secondary" onClick={() => toastManager.info('Info', 'Logs feature coming soon')}>
                        <i className="fas fa-file-alt"></i> View Logs
                    </button>
                    
                    <button className="admin-btn admin-btn-secondary" onClick={() => window.location.reload()}>
                        <i className="fas fa-sync-alt"></i> Clear Cache
                    </button>
                </div>
                
                <div style={{ marginTop: '30px', padding: '20px', background: 'rgba(255,184,0,0.1)', borderRadius: '12px', border: '1px solid rgba(255,184,0,0.3)' }}>
                    <h4 style={{ color: '#ffb800', margin: '0 0 10px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fas fa-info-circle"></i> System Information
                    </h4>
                    <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem', lineHeight: '1.8' }}>
                        <div><strong>Version:</strong> DinoShort Admin v1.2</div>
                        <div><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</div>
                        <div><strong>Status:</strong> <span style={{ color: '#00d084' }}>✓ All Systems Operational</span></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SettingsSection;

